import React from "react"
import { createPerformanceTableTool } from "@/editor/createPerformanceTableTool"

export const SmallPerformanceByAssetClassTableTool = createPerformanceTableTool(
  {
    type: "small_performance_by_asset_class_table",
    headerText: "Performance by Asset Class",
    columnHeader: "Asset Class",
    dataProperty: "asset_class",
    toolboxTitle: "Asset Class Performance Table",
  },
)
